import React from "react";
import { AllDeshbordCountData } from "../../FetchAPI";
import Sidebar from "../Sidebar";
import DeshBoardFooter from "../DeshBoardFooter";
import CountTotalDataBox from "./CountTotalDataBox";
import "./AllCatServiceWiseLeads.css";
// import AllCategoryBoxTabs from "./AllCategoryBoxTabs";
import { AllServicesCategory } from "../../FetchAPI";
import AllTotalLead from "./AllTotalLead";
import { useAuth } from "../../../Store/AuthContext";
import { Helmet } from "react-helmet";

export default function AllCatServiceWiseLeads() {
  const { RendomTokenfetch } = useAuth();
  const [DeshbordCount] = AllDeshbordCountData(RendomTokenfetch);
  const [AllserviceCat] = AllServicesCategory(RendomTokenfetch);
  // console.log(AllserviceCat);
  return (
    <>
      <Helmet>
        <meta name="robots" content="index, follow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <div className="sidebar-backdrop"></div>
        <Sidebar />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            <div className="row">
              {DeshbordCount &&
                DeshbordCount.map((value, index) => (
                  <CountTotalDataBox key={index} countData={value} />
                ))}
            </div>
          </div>
        </section>

        <section className="user-dashboard">
          <div className="dashboard-outer">
            <div className="row">
              <div className="sectitle">
                <h5 className="secheading">All Services</h5>
              </div>
            </div>
            <div className="row">
              {/* <AllCategoryBoxTabs
                  RendomTokenfetch={RendomTokenfetch}
                  AllserviceCat={AllserviceCat}
                /> */}
              <AllTotalLead
                RendomTokenfetch={RendomTokenfetch}
                AllserviceCat={AllserviceCat}
              />
            </div>
          </div>
        </section>

        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
